module.exports = "<div class=\"spinner-container\">\r\n    <mdl-spinner [active]=\"true\"></mdl-spinner>\r\n</div>"